import { render } from "./NewRevenueReportsPage.vue?vue&type=template&id=711404b3"
import script from "./NewRevenueReportsPage.vue?vue&type=script&lang=js"
export * from "./NewRevenueReportsPage.vue?vue&type=script&lang=js"

import "./NewRevenueReportsPage.vue?vue&type=style&index=0&id=711404b3&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__